import { MyAccountUrls, MY_ACCOUNT_BRAND_QUERY_PARAM } from '../common/constants';
import parseQueryParams from './parseQueryParams';

const getOrigin = () => (typeof window !== 'undefined' ? window.location.origin : '');

const isDevelopment = () => /uat|dev|localhost/.test(getOrigin());
const isStaging = () => /staging/.test(getOrigin());

const getRedirectBrand = () =>
  (typeof window !== 'undefined' ? parseQueryParams(window.location.search || '')[MY_ACCOUNT_BRAND_QUERY_PARAM] : null);

export const getAssetsBaseUrl = () => isDevelopment() || isStaging()
    ? 'https://assets.dev.wireless.radio'
    : 'https://assets.wireless.radio';

export const getAssetUrl = (path) => `${getAssetsBaseUrl()}/${path}`;

export const getMyAccountUrl = () => {
  let baseUrl = MyAccountUrls.prod;
  if (isStaging()) baseUrl = MyAccountUrls.staging;
  else if (isDevelopment()) baseUrl = MyAccountUrls.development;

  const redirectBrand = getRedirectBrand();
  return redirectBrand ? `${baseUrl}/?${MY_ACCOUNT_BRAND_QUERY_PARAM}=${redirectBrand}` : baseUrl;
};